import StadiumMaterialuHistoria from '../model/legislativnyMaterial/StadiumMaterialuHistoria';
import { StadiumMaterialuEnum } from '../model/legislativnyMaterial/StadiumMaterialu';

function hasBeenInStadium(
  stadium: StadiumMaterialuEnum,
  historiaRecords: Array<StadiumMaterialuHistoria>,
): boolean {
  return historiaRecords?.map(record => record.stadium.hodnota).includes(stadium);
}

function hasBeenInUkonceneStadiumMpk(
  historiaRecords: Array<StadiumMaterialuHistoria>,
): boolean {
  return historiaRecords?.some(record => record.stadium.hodnota
      === StadiumMaterialuEnum.MPK && record.datumUkoncenia !== null);
}

const additionalAttributeKodList = ['Vyhlaska', 'NariadenieVlady',
  'PoslaneckyNavrhZakon', 'UstavnyZakon', 'Zakon', 'PoslaneckyNavrhUstavaSR', 'PoslaneckyNavrhUstavnyZakon'];
const basicAttributeKodList = ['Opatrenie'];
const onlyHlavnyPredpisKodList = ['Vyhlaska', 'NariadenieVlady'];

function arrayIncludesInObj(
  array: Array<string>,
  key: string,
): boolean {
  return array.some(e => e === key);
}

export {
  hasBeenInStadium,
  hasBeenInUkonceneStadiumMpk,
  arrayIncludesInObj,
  additionalAttributeKodList,
  basicAttributeKodList,
  onlyHlavnyPredpisKodList,
};
